import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'receipt.useGtinAsSerialWhenQtyOne'.
 * Styrer om innskannet varenummer/GTIN skal brukes direkte som serienummer
 * i Fritt mottak for serienummerhåndterte varer (ItemType=6) når antallet er 1 —
 * slik at operatøren slipper å bekrefte serienummeret på nytt i egen modal.
 *
 * Gjelder KUN når mottatt antall = 1. Ved større antall vises alltid
 * serienummer-modalen som før.
 *
 * Settes på systemnivå (AllowProfileLevel=false), men hooket bruker getEffectiveSetting
 * slik at et eventuelt fremtidig profilnivå respekterer hierarkiet (Profile → System → Default).
 *
 * Default: false (bakoverkompatibelt — serienummer-modalen vises som før).
 */
export function useGtinAsSerialWhenQtyOne(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('receipt.useGtinAsSerialWhenQtyOne');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load receipt.useGtinAsSerialWhenQtyOne setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
